<section id="top" class="relative overflow-hidden pt-24 pb-2 sm:pb-32 lg:pt-32 lg:pb-48">
  <div
    class="pointer-events-none absolute -top-20 -left-24 w-[520px] h-[520px] rounded-full bg-indigo-300/25 blur-[120px]">
  </div>
  <div
    class="pointer-events-none absolute top-40 right-0 w-[460px] h-[460px] rounded-full bg-violet-300/20 blur-[120px]">
  </div>
  <div class="pointer-events-none absolute inset-0 opacity-[0.5] hero-bg-pattern"></div>

  <div class="relative max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-6 sm:gap-12 lg:gap-8 items-center">
    <!-- Left Column (Content) -->
    <div class="lg:col-span-5">
      <div
        class="inline-flex items-center gap-2 rounded-full border border-indigo-100 bg-indigo-50/80 px-3.5 py-1.5 text-xs font-semibold text-indigo-700">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-3.5 h-3.5">
          <path d="M12 2L15 9L22 12L15 15L12 22L9 15L2 12L9 9L12 2Z" />
        </svg>
        AI-POWERED HIRING PLATFORM
      </div>

      <h1
        class="mt-4 font-display font-extrabold tracking-tighter text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] text-slate-900">
        <span class="block py-1">Your <span class="brand-gradient-text pb-2">Smart</span></span>
        <span class="block py-1"><span class="brand-gradient-text pb-2">Hiring</span> Partner.</span>
      </h1>

      <p class="mt-6 max-w-xl text-base sm:text-lg text-slate-600 leading-relaxed">
        Choose the hiring model that works best for you let our recruitment experts handle your complete hiring process,
        or use the BeExpert AI platform to post jobs, screen candidates, conduct assessments & interviews and hire with
        confidence.
      </p>

      <div class="mt-8 flex items-stretch gap-2 sm:gap-3 w-full sm:w-auto max-w-sm sm:max-w-none">
        <button class="hero-btn-outline group flex-1" (click)="openDemoModal('quote')">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            class="w-5 h-5 text-indigo-500 transition-transform group-hover:-translate-y-0.5">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
          <span class="whitespace-nowrap">Get a Quote</span>
        </button>
        <button class="hero-btn-email flex-1" routerLink="/company-auth">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-5 h-5">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
          <span class="whitespace-nowrap">Signup Free</span>
        </button>
      </div>

      <!-- Recruiter stats instead of candidate chips -->
      <div class="mt-6 flex items-center justify-start gap-4 sm:gap-8 max-w-2xl divide-x divide-slate-200">
        <div class="flex flex-col">
          <span class="text-2xl sm:text-3xl font-extrabold text-slate-700 tracking-tight">{{ stats.candidatesEval
            }}K+</span>
          <span class="text-[9px] sm:text-[10px] text-slate-400 font-semibold uppercase tracking-widest mt-1">Candidates
            Evaluated</span>
        </div>
        <div class="flex flex-col pl-4 sm:pl-8">
          <span class="text-2xl sm:text-3xl font-extrabold text-slate-700 tracking-tight">{{ stats.companies }}+</span>
          <span class="text-[9px] sm:text-[10px] text-slate-400 font-semibold uppercase tracking-widest mt-1">Trusted By
            Companies</span>
        </div>
        <div class="flex flex-col pl-4 sm:pl-8">
          <span class="text-2xl sm:text-3xl font-extrabold text-slate-700 tracking-tight">{{ stats.fasterHiring
            }}x</span>
          <span class="text-[9px] sm:text-[10px] text-slate-400 font-semibold uppercase tracking-widest mt-1">Faster
            Hiring</span>
        </div>
      </div>
    </div>

    <!-- Right Column (Animated Image Showcase) -->
    <div
      class="lg:col-span-7 relative w-full max-w-[900px] mx-auto mt-2 sm:mt-12 lg:mt-0 flex items-center justify-center lg:ml-auto animate-float">
      <div class="absolute right-6 top-6 w-64 h-64 rounded-full bg-indigo-500/20 blur-[100px] animate-glow-pulse"></div>
      <div class="absolute left-4 bottom-10 w-56 h-56 rounded-full bg-violet-500/15 blur-[90px]"></div>

      <div
        class="relative z-10 w-full rounded-2xl overflow-hidden shadow-[0_30px_60px_-15px_rgba(79,70,229,0.2)] border border-slate-200/50 transition-all duration-700 bg-white group cursor-pointer p-2">
        <div class="relative rounded-xl overflow-hidden bg-white">
          <img src="assets/images/recruiter-dashboard.png" alt="BeExpert Recruiter Dashboard"
            class="w-full h-auto block transition-transform duration-[1.5s] group-hover:scale-105" />

          <!-- Glossy Sweep Effect -->
          <div
            class="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent w-[50%] animate-sweep pointer-events-none">
          </div>

          <!-- Subtle Gradient Overlay -->
          <div
            class="absolute inset-0 bg-gradient-to-tr from-indigo-900/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none">
          </div>
        </div>
      </div>
    </div>

    <!-- OLD MOCKUP (Removed to fix Angular nested comment parsing errors) -->
  </div>
</section>

<!-- Demo Modal -->
<app-book-demo-modal *ngIf="isDemoModalOpen" [initialOption]="selectedModalOption" (close)="closeDemoModal()"></app-book-demo-modal>